@if (shouldShowBanner$ | ngrxPush) {
  <div
    class="manager-permission-changes-reminder-container white-text status"
    role="status"
    *ngrxLet="currentUser$ as currentUser">
    <div class="left">
      <terra-icon icon="info-circle" variant="regular"></terra-icon>
    </div>

    <div class="center">
      <div class="header">{{ getCopy(currentUser.roleCode) }}</div>
    </div>

    <div class="right">
      <div>
        <ninety-button
          flat
          secondary
          icon
          aria-label="Dismiss manager permission changes notification"
          (click)="dismissManagerPermissionChangesNotification()">
          <terra-icon class="white-text" icon="x" />
        </ninety-button>
      </div>
    </div>
  </div>
}
